module.exports = __webpack_public_path__ + "img/active_filters.4cd7f8f7.svg";